<template lang='pug'>
div(v-if="infos.length > 0" :class='"static-middle"')
  SectionTitle(:sectionText='partner.title' :subtitleSection='true' :subtitleText='partner.subtitle')
  ul.static-partnerList
    PartnerGrid(v-for='(info, idx) in infos'
      :isEdu='isEdu'
      :key='idx'
      :idx='idx + 1'
      :info='info'
      :type='type'
    )
</template>
<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import PartnerGrid from '@/components/static/partner_grid.vue'

export default {
  props: {
    partner: Object,
    type: String,
    isEdu: Boolean,
  },
  components: {
    PartnerGrid,
    SectionTitle
  },
  data() {
    return {
      infos: [],
      text: []
    }
  },
  created() {
    switch (this.type) {
      case "partners":
        return this.getInfo();
      case "govPartners":
        return this.getGovInfo();
      case "eduPartners":
        return this.getEduInfo();
    }
  },
  methods: {
    async getInfo() {
      let route = this.$store.state.URLs.api + '/' + this.$store.state.lang + '/' + this.type
      let result = await this.$axios.get(route);
      this.infos = Object.values(result.data.content);
    },
    async getGovInfo() {
      let route = this.$store.state.URLs.api + '/' + this.$store.state.lang + this.$store.state.routes.govPartners
      let result = await this.$axios.get(route)
      this.infos = Object.values(result.data.content);
    },
    async getEduInfo() {
      let route = this.$store.state.URLs.api + '/' + this.$store.state.lang + this.$store.state.routes.eduPartners
      let result = await this.$axios.get(route);
      this.infos = Object.values(result.data.content);
    }
  }
}
</script>
